import { makeAutoObservable } from 'mobx';

export default class AdministrationStore {
    constructor() {
        this._meetings = [];
        this._verbalProcedure = [];
        this._specialCommitteesMeets = [];

        makeAutoObservable(this);
    }

    setMeetings(meetings) {
        this._meetings = meetings;
    }
    get meetings() {
        return this._meetings;
    }

    setVerbalProcedure(verbalProcedure) {
        this._verbalProcedure = verbalProcedure;
    }
    get verbalProcedure() {
        return this._verbalProcedure;
    }

    setSpecialCommitteesMeets(specialCommitteesMeets) {
        this._specialCommitteesMeets = specialCommitteesMeets;
    }
    get specialCommitteesMeets() {
        return this._specialCommitteesMeets;
    }
}
